// src/api.js
const baseUrl = process.env.NODE_ENV === 'production'
? 'https://backend.myevento-digital.com:3002' // Cambiado a HTTPS para producción
: 'http://localhost:3002';  // URL de desarrollo
console.log('Base URL:', baseUrl);

export default baseUrl;
